<template>
	<div class="ss-data list__box__body list__box__body--grid exercise-subject__list">
		<div class="box_content">
			<div class="row" v-if="dataSource.length > 0">
				<div class="col-md-4 col-sm-6 item"  v-for="(item,index) of dataSource" :key="index">
					<div class="item__wrap position-rel text-center">
						<div class="item__head text-center">
						
							<a href="javascript:;" @click="goToExerciseDetail(item)">
								<img
								v-lazy="item.imageUrl != null && item.imageUrl != '' ? handleResizeImg(item.imageUrl) : thumbUrl('_ketnoitrithuc.png') "
								:alt="item.name"
								/>
							</a>
						</div>
						<div class="item__body">
							<h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt">
								<a href="javascript:;" class="primary-color-txt" @click="goToExerciseDetail(item)">
									{{item.name}}
								</a>
							</h3>
							<p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ item.manufactureYear }}</p>
						</div>
					</div>
				</div>
			</div>
			<p v-else class="m-3 secondary-color-txt text-center font-size-20">
				Đang cập nhật Sách lên hệ thống
			</p>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapGetters } from "vuex";
	import { STORE_KEY } from "../../_store/constants";
	import { APP_CONFIG } from "@/utils/constants";
	import { LOCAL_SAVE_PRACTICE_LIST, LOCAL_SAVE_EXERCISE_CLASS } from "../../_store/constants";
	// import {LOCAL_SAVE_EXERCISE_DETAIL_ROUTE} from "../../_store/constants";
  	import Pagination from "@/components/Pagination.vue";
  	import { replaceImageResize } from '@/helpers/functions'
  // import { APP_CONFIG } from "@/utils/constants";

	export default {
		name: 'ExerciseSubject',
		components: {
			Pagination,
		},
		props: {
			dataSource: Array
		},
		data () {
			return {
        // classId : $route
    		appUrl: APP_CONFIG.appUrl,
   			cdnUrl: APP_CONFIG.cdnUrl,
				classId: this.$route.params.classId,
				subjectId: this.$route.params.subjectId,
			}
		},
		computed: {
			...mapGetters({
				exerciseClassCurr: STORE_KEY + "/exerciseClassCurr",
			})
		},

	methods:{

		goToExerciseDetail(item) {
			let dataLocalSave = {...item, ...this.exerciseClassCurr, bookName: item.name};
			localStorage.setItem(LOCAL_SAVE_EXERCISE_CLASS, JSON.stringify(dataLocalSave));
			// localStorage.setItem(LOCAL_SAVE_EXERCISE_DETAIL, item.name);
			// localStorage.setItem(LOCAL_SAVE_EXERCISE_DETAIL_ROUTE,JSON.stringify({classId:this.classId,subjectId:this.subjectId}) );
			// localStorage.setItem(LOCAL_SAVE_ID, this.classActive);
			if (item.lastBookIndexId && item.lastBookIndexId > 0) {
				this.$router.push({name: "exerciseDetail", params:{id: item.bookId}, query: {danhmuc: item.lastBookIndexId}});
			} else {
				this.$router.push({name: "exerciseDetail", params:{id: item.bookId}});
			}
		},
		thumbUrl(filename) {
			return require(`@/assets/img/${filename}`);
		},

		handleResizeImg (link) {
	        return replaceImageResize(link, {width: 285, height: 404})
	    }
	}
}
</script>
<style lang="scss" scoped>
	// .item {
	// 	margin-bottom: 20px;
	// }
</style>